import React from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Row } from 'react-bootstrap';
import CLabel from '../../../../components/Common/CLabel';
import { useDispatch, useSelector } from 'react-redux';
import { action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen, action_updateContractSubPartieSelected, action_updateContractSubPartieSelectedId } from '../../../../reducers/actions/PAY/actions';
import { enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE } from '../../../../common/Dictionaries';
import TablePolynomyItem from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItem';
import { __calculateTotalRestAdjustmentAmount } from '../../../../common/CommonFuctions';
import TablePolynomyItemNotAdjustment from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItemNotAdjustment';

import './style.css'
import 'react-datepicker/dist/react-datepicker.css';
import { _handleDeletePolynomyClick } from '../../Events';
import { formatNumber, isNullOrEmpty, isNullUndefined } from '../../../../common/Helpers';

const SidePanelViewContractSubPartie = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        _contractPartieSelected: contractPartieSelected,
        _contractSubPartieSelected: contractSubPartieSelected,
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
        _contractFormSubPartieConfig: contractFormSubPartieConfig,
    } = useSelector((state) => state.contractPartiesState);

    const onDismissPanel = () => {
        dispatch(action_updateContractSubPartieSelectedId(null))
        dispatch(action_updateContractSubPartieSelected(null))
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_VIEW, false))
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const totalRestAdjustmentAmount = __calculateTotalRestAdjustmentAmount(contractSubPartieSelected.l_POLINOMIO);

    return (
        <div>
            <Panel
                isOpen={ contractPartieSidePanelsConfig.isPanelViewSubPartieOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-subpartieform') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    contractSubPartieSelected.iteM_SUBPARTIDA &&
                    <div>
                        <div>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-partieinfo') }</h5></div>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiename') } labelValue={ contractPartieSelected.iteM_PARTIDA.nombrePartida } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecode') } labelValue={ contractPartieSelected.iteM_PARTIDA.codigoPartida } />
                                </Col>
                                
                             </Row>
                             <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partietype') } labelValue={ contractPartieSelected.iteM_PARTIDA.tipoPartidaTitle } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieclass') } labelValue={ contractPartieSelected.iteM_PARTIDA.clasePartidaTitle } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecurrency') } labelValue={ contractPartieSelected.iteM_PARTIDA.monedaPartida } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonth') } labelValue={ contractPartieSelected.iteM_PARTIDA.mesPrevio } />
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-subpartieinfo') }</h5></div>
                            <Row>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartiecode') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.codigoRecurso } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartienumber') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.nroRecurso } />
                                </Col>
                             </Row>
                             <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartiename') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.nombreRecurso } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieclass') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.clasePartidaTitle } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartietype') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.tipoPartidaTitle } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevmonthexpensebase') } labelValue={ !isNullOrEmpty(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioBaseRecurso) ? formatNumber(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioBaseRecurso, 10) : "" } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevexpensemonthadjunst') } labelValue={ !isNullOrEmpty(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso) ? formatNumber(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevexpensedifference') } labelValue={ !isNullOrEmpty(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc) ? formatNumber(contractSubPartieSelected.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc, 10) : "" } />
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-aditionalsubpartieinfo') }</h5></div>
                            <Row>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartietotalamountsumalz') } labelValue={ !isNullOrEmpty(contractSubPartieSelected.iteM_SUBPARTIDA.montoTotalSumaAlzada) ? formatNumber(contractSubPartieSelected.iteM_SUBPARTIDA.montoTotalSumaAlzada, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieserviceunit') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.unidadPartidaTitle } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieunitpricebase') } labelValue={ !isNullOrEmpty(contractSubPartieSelected.iteM_SUBPARTIDA.precioUnitarioBaseRecurso) ? formatNumber(contractSubPartieSelected.iteM_SUBPARTIDA.precioUnitarioBaseRecurso, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-totalsubpartieamount') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.cantidadTotalRecurso } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-prevsubpartieamount') } labelValue={ contractSubPartieSelected.iteM_SUBPARTIDA.cantidadPreviaRecurso } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-internalcode') } labelValue={ !isNullUndefined(contractSubPartieSelected.iteM_SUBPARTIDA.codigoInterno) ? contractSubPartieSelected.iteM_SUBPARTIDA.codigoInterno : t('no-data') } />
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            {
                                contractSubPartieSelected.l_POLINOMIO && contractSubPartieSelected.l_POLINOMIO.map((polynomy, index) => (
                                    <Col xl={6}>
                                        <TablePolynomyItem
                                            key={index}
                                            parentId={contractSubPartieSelected.iteM_SUBPARTIDA.id}
                                            parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.SUBPARTIE}
                                            tableItem={polynomy}
                                            polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT}
                                            addCardWidth={false}
                                            handleDeletePolynomy={_handleDeletePolynomyClick}
                                        />
                                    </Col>
                                ))
                            }
                            {
                                totalRestAdjustmentAmount > 0 &&
                                <TablePolynomyItemNotAdjustment totalRestAdjustmentAmount={totalRestAdjustmentAmount} addCardWidth={false} />
                            }
                        </Row>
                    </div>
                }
            </Panel>
        </div>
    );
};

SidePanelViewContractSubPartie.propTypes = {
};

export default SidePanelViewContractSubPartie;